import { render } from "./SidebarIndex.vue?vue&type=template&id=b0e5e6d0"
import script from "./SidebarIndex.vue?vue&type=script&lang=js"
export * from "./SidebarIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__